// library imports
import { useDispatch } from "react-redux";

// User Component imports
import { ApiRequest } from "_core/apis/ApiRequest";
import { setApiTimestamp } from "_core/slices/datas/TransactionSlice";

const AdminAccountDeleteApi = () => {
    const dispatch = useDispatch();

    // API固有の設定、URLとリクエスト
    const url = "/admin/account_delete";

    // API実行, t_account_id
    const ExecAdminAccountDeleteApi = async (t_account_id) => {

        // 必要なリクエストを定義
        const requestParams = {
            t_account_id: t_account_id,
        };

        let response = null;
        let error = null;

        try {
            response = await ApiRequest({ url:url, requestParams:requestParams });
        } catch (e) {
            error = e;
        }

        if (response !== null && response.error_code === 0) {
            dispatch(setApiTimestamp(response['now_time']));
        }
        return { response, error };
    };

    return ExecAdminAccountDeleteApi;
};

export default AdminAccountDeleteApi;
